/* eslint-disable @typescript-eslint/naming-convention */
export enum PaymentStatusAvailableOptionsEnum {
    BARGELD = 1,
    PAYBACK = 4,
    PLUSBONUS = 8,
}
